import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

export const canActivateGuardFn: CanActivateFn = (_: ActivatedRouteSnapshot, __: RouterStateSnapshot) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    if (!authService.isAuthenticated()) {
        router.navigate(['/login']);
        return false;
    }
    return true;
};

export const canActivateChildGuardFn: CanActivateChildFn = (_: ActivatedRouteSnapshot, __: RouterStateSnapshot) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    if (!authService.isAuthenticated()) {
        router.navigate(['/login']);
        return false;
    }
    return true;
};